import { h, Fragment, render, Component } from 'preact';

import 'preact/compat'

import './index.css'
import './css/nearme-symbols.css'
import NearMeMap, { SizedNearMeMap } from './components/near-me-map'
import InfoPanel from './components/info-panel'

document.querySelectorAll(".nm-map").forEach(el => {
    const {
        apiKey,
        href,
        serviceStations,
        serviceStationId,
        idField,
        idParam,
        region,
        language,
        filterStations,
        zoom,
        dataLayer
    } = el.dataset

    const props = {
        serviceStationId,
        idField,
        idParam,
        region,
        language,
        filterStations,
        zoom,
        dataLayer: window[dataLayer || 'dataLayer'] || []
    }

    if (href) {
        fetch(href)
            .then(r => r.json())
            .then(json => render(<SizedNearMeMap apiKey={apiKey} serviceStations={json} {...props} />, el));
    }
    else if (serviceStations) {
        render(<SizedNearMeMap apiKey={apiKey} serviceStations={serviceStations} {...props} />, el)
    }
})

document.querySelectorAll(".nm-info-panel").forEach(el => {
    const {
        apiKey,
        href,
        serviceStations,
        serviceStationId,
        idField,
        idParam,
        region,
        language,
        filterStations,
        zoom,
        dataLayer
    } = el.dataset

    const props = {
        serviceStationId,
        idField,
        idParam,
        region,
        language,
        filterStations,
        zoom,
        dataLayer: window[dataLayer || 'dataLayer'] || []
    }

    if (href) {
        fetch(href)
            .then(r => r.json())
            .then(json => render(<InfoPanel apiKey={apiKey} serviceStations={json} {...props} />, el));
    }
    else if (serviceStations) {
        render(<InfoPanel apiKey={apiKey} serviceStations={serviceStations} {...props} />, el)
    }
})
